import PropTypes from 'prop-types';
import Description from 'Shared/components/description';
import Button from 'Shared/components/button';
import { useTranslation } from 'Shared/util/custom-hooks';
import BaseModal from './base-modal';


const ConfirmationModal = ({
  isModalOpen,
  closeModal,
  headerText,
  contentText,
  confirmText,
  onConfirm,
}) => {
  const tg = useTranslation(x => x.global);

  const handleClose = () => closeModal();

  const handleConfirm = () => {
    closeModal();
    onConfirm();
  };

  return (
    <BaseModal
      isModalOpen={isModalOpen}
      closeModal={closeModal}
      headerText={headerText}
      content={contentText && <Description text={contentText} />}
      buttons={[
        <Button
          buttonType="button-secondary"
          onClick={handleClose}
          text={tg.cancel}
        />,
        <Button
          onClick={handleConfirm}
          text={confirmText}
        />,
      ]}
    />
  );
};

ConfirmationModal.propTypes = {
  isModalOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  headerText: PropTypes.string,
  contentText: PropTypes.string,
  confirmText: PropTypes.string.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

export default ConfirmationModal;
